import { useNavigate } from "react-router-dom";
import { useNotificationsContext } from "../../context";
import { getActiveModule } from "../../../../services/BaseService";
import { useApplications } from "../../../../context/Applications";
import { StorageManager } from "datastake-daf/src/helpers/StorageManager";
import { useSelector } from "react-redux";

export const renderNotiBody = ({ n }) => {
  switch (n.type) {
    default:
      return (
        <label>{n.body}</label>
      );
  }
}

export const renderNotiTitle = ({ n }) => {
  return n.title;
}

const NOTIFICATION_TYPES = {
  PROJECT_SOURCE_INVITE: 'projectSourceInvite',
  PROJECT_CLIENT_INVITE: 'projectClientInvite',
  PROGRAM_CLIENT_INVITE: 'programPartnerInvite',
  MINE_PROFILE_APPROVE: 'mineProfileApprove',
  KYC_APPROVE: 'kycFormApprove',
  APP_FORM_APPROVE: "applicationFormApprove",
  MINE_PROFILE_DECLINED: 'mineProfileDeclined',
  KYC_DECLINED: 'kycFormDeclined',
  APP_FORM_DECLINED: "applicationFormDeclined",
  MINE_PROFILE_SUBMITTED: 'mineProfileSubmitted',
  KYC_SUBMITTED: 'kycFormSubmitted',
  APP_FORM_SUBMITTED: "applicationFormSubmitted",
  PARTNER_INVITATION: 'partnerInvitation',
  APPROVED_PARTNER: 'approvedPartner',
  DECLINED_PARTNER: 'declinedPartner',
  UPDATE_PARTNERSHIP_TYPE: 'updatePartnershipType',
  SUSPEND_PARTNERSHIP: 'suspendPartnership',
};

export const useOnClickResponse = ({ n, toggle = () => { } }) => {
  const { removeNotification } = useNotificationsContext();
  const { applications } = useApplications();
  const goTo = useNavigate();
  const { user } = useSelector((state) => state.authentication);

  const onClick = () => {
    toggle();
    removeNotification(n.id);

    const activeModule = getActiveModule();
    const userModules = Object.keys(user.modules);
    const app = applications.find((a) => (a?.modules || []).includes(n?.data?.module));
    const _module = userModules.find((m) => (app?.modules || []).includes(m));

    const mod = _module || activeModule;
    const doRedirect = activeModule !== mod;

    if (mod) {
      let path;

      switch (n.type) {
        case NOTIFICATION_TYPES.PARTNER_INVITATION:
          path = `/app/${mod}/partners?tab=requests`;
          break;
        case NOTIFICATION_TYPES.APPROVED_PARTNER:
        case NOTIFICATION_TYPES.DECLINED_PARTNER:
        case NOTIFICATION_TYPES.UPDATE_PARTNERSHIP_TYPE:
        case NOTIFICATION_TYPES.SUSPEND_PARTNERSHIP:
          path = `/app/${mod}/partners`;
          break;
        case NOTIFICATION_TYPES.PROJECT_SOURCE_INVITE:
        case NOTIFICATION_TYPES.PROJECT_CLIENT_INVITE:
          path = `/app/${mod}/projects/invitations`;
          break;
        case NOTIFICATION_TYPES.PROGRAM_CLIENT_INVITE:
          path = `/app/${mod}/programs?status=pending`;
          break;
        case NOTIFICATION_TYPES.MINE_PROFILE_APPROVE:
        case NOTIFICATION_TYPES.MINE_PROFILE_DECLINED:
          path = `/app/${mod}/view/mine-profile/user`;
          break;
        case NOTIFICATION_TYPES.MINE_PROFILE_SUBMITTED:
          path = `/app/${mod}/view/mine-profile/${n?.data?.datastakeId}?sourceId=${n?.data?.authorId}`;
          break;
        case NOTIFICATION_TYPES.KYC_APPROVE:
        case NOTIFICATION_TYPES.KYC_DECLINED:
          path = `/app/${mod}/view/ownership-kyc/user`;
          break;
        case NOTIFICATION_TYPES.KYC_SUBMITTED:
          path = `/app/${mod}/view/ownership-kyc/${n?.data?.datastakeId}?sourceId=${n?.data?.authorId}`;
          break;
        case NOTIFICATION_TYPES.APP_FORM_APPROVE:
        case NOTIFICATION_TYPES.APP_FORM_DECLINED:
          path = `/app/${mod}/view/amp/user`;
          break;
        case NOTIFICATION_TYPES.APP_FORM_SUBMITTED:
          path = `/app/${mod}/view/amp/${n?.data?.datastakeId}?sourceId=${n?.data?.authorId}`;
          break;
        default:
      }

      if (path) {
        if (doRedirect) {
          const appLink = applications.find((a) => a.modules.includes(mod))?.appLink;
          if (appLink) {
            window.location.href = `${appLink}/app-redirect?module=${mod}&token=${StorageManager.get('token')}&path=${path}`
          }
          return;
        }

        goTo(path);
      }
    }
  }

  return { onClick };
}
